import { CoursesBlockCombinedProps } from './types';

const usePresenter = (props: CoursesBlockCombinedProps): CoursesBlockCombinedProps => {
  return props;
};

export default usePresenter;
